/**
 * 商行健康度 - Redux reducer
 * 保存查询条件、列表数据、分页、loading
 */
import * as actionTypes from '../constant/stallHealth';

export const DEFAULT_FILTERS = {
  pactStatusList: [1],
};

const initState = {
  queryFilters: DEFAULT_FILTERS,
  list: [],
  total: 0,
  healthLevel: null,
  healthScore: null,
  pageNo: 1,
  pageSize: 10,
  loading: false,
};

export function stallHealth(state = initState, action) {
  switch (action.type) {
    case actionTypes.STALL_HEALTH_SET_FILTERS:
      return {
        ...state,
        queryFilters: { ...DEFAULT_FILTERS, ...action.payload },
        pageNo: 1,
      };
    case actionTypes.STALL_HEALTH_SET_LIST:
      return {
        ...state,
        list: action.payload.list || [],
        total:
          action.payload.total != null ? action.payload.total : (action.payload.list || []).length,
        healthLevel: action.payload.healthLevel ?? null,
        healthScore: action.payload.healthScore ?? null,
      };
    case actionTypes.STALL_HEALTH_SET_PAGINATION:
      return {
        ...state,
        pageNo: action.payload.pageNo != null ? action.payload.pageNo : state.pageNo,
        pageSize: action.payload.pageSize != null ? action.payload.pageSize : state.pageSize,
      };
    case actionTypes.STALL_HEALTH_SET_LOADING:
      return { ...state, loading: !!action.payload };
    case actionTypes.STALL_HEALTH_RESET:
      return {
        ...state,
        queryFilters: DEFAULT_FILTERS,
        pageNo: 1,
        list: [],
        total: 0,
        healthLevel: null,
        healthScore: null,
      };
    default:
      return state;
  }
}
